/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const pdpListPriceDisplaySX: SxProps<Theme> = {
	color: (theme) => theme.palette.text.secondary,
	fontWeight: 'bold',
	fontSize: '14px !important',
	padding : 0.5,
	lineHeight:1,
};

export const pdpOfferPriceDisplaySX = ({list, offer}:{list:number, offer:number}):SxProps => ({
	fontSize:'20px !important',
	color:list === 0 || list===offer? '#000' : 'text.offerPrice', 
	fontWeight:'bold',
	padding : 0.5,
	lineHeight:1.2,
})